<script>
import BaseModal from '../../BaseModal';
import BaseInputPhone from '../../BaseInputPhone';
import BaseInputDeadline from '../../BaseInputDeadline';
import FormService from '../../../services/FormService';
import {email, minLength, required} from 'vuelidate/lib/validators';
import TokenService, {token} from "@/services/TokenService";
import {IDENTITY_SERVICE} from "@/defaults";

export default {
  name: 'ProfileMenuModalInfo',
  components: {
    BaseModal,
    BaseInputPhone,
    BaseInputDeadline,
  },
  data() {
    return {
      model: new FormService({
        userId: 0,
        firstName: '',
        lastName: '',
        middleName: '',
        birthDate: null,
        resourceFile: {
          id: null,
        },
        photoUrl: '',
        user: {
          id: 0,
          userName: '',
          email: '',
          phoneNumber: '',
        },
      }),
      userNameEdit: false,
      oldUserName: ''
    };
  },
  validations: {
    model: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      user: {
        // userName: {
        //   required,
        // },
        // email: {
        //   required,
        //   email,
        // },
        phoneNumber: {
          required,
          minLength: minLength(9),
        },
      },
    },
  },
  mounted() {
    $('#profileModal').on('show.bs.modal', () => {
      let data = this.$store.state.userProfile;
      this.model.SetData({
        userId: data.id,
        firstName: data.firstName,
        lastName: data.lastName,
        middleName: data.middleName,
        birthDate: data.birthDate ? data.birthDate : null,
        photoUrl: data.photoUrl ? data.photoUrl : '',
        user: {
          id: data.id,
          userName: data.userName,
          email: data.email,
          phoneNumber:  data.phoneNumber,
          companyId: data.companyId,
          officeId: data.officeId,
          departmentId: data.departmentId,
        },
      });
      this.oldUserName = data.userName
    });

    $('#profileModal').on('hidden.bs.modal', () => {
      this.$v.$reset();
      this.model.Reset();
    });
  },

  methods: {
    Logout() {
      token.Logout()

    },
    Save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.oldUserName !== this.model.user.userName) {
        this.userNameEdit = true;
      }
      let postData = this.model.GetData();
      postData.birthDate =
          this.$moment(postData.birthDate).isValid() ? this.$moment(postData.birthDate).format('DD-MM-YYYY') : null;

      this.$api
          .put('employees/profile/update', postData)
          .then(response => {
            $('#profileModal').modal('hide');
            this.GetProfileInfo();
            this.$notification.success(this.$t('profileEdited'));
            if (this.userNameEdit) {
              this.Logout();
            }
            window.location.reload();
          })
          .finally(() => {

          });
    },
    UploadPhoto(event) {
      if (event.target.files.length === 0) {
        return;
      }


      let formData = new FormData();
      formData.append('file', event.target.files[0]);


      this.$store.state.loader = true;
      this.$api
          .post('/resource/upload/file', formData, {
            params: {
              minWidth: 100,
              minHeight: 100,
            }
          })
          .then(response => {
            this.model.photoUrl = response.data.data.url;
            this.model.resourceFile.id = response.data.data.id;
          })
          .finally(() => {
            event.target.value = '';
            this.$store.state.loader = false;
          });
    },
    DeletePhoto() {
      this.model.photoUrl = '';
      this.model.resourceFile.id = null;
    },
    GetProfileInfo() {
      this.$api
          .get('users/me')
          .then(response => {
            this.$store.state.userProfile = response.data.data;
          }).catch(e=>{
        TokenService.token.Remove()
        if(!window.location.href.includes('is_dev')){
          window.location.href = IDENTITY_SERVICE
        }
      });;
    },
  },

};
</script>

<template src="./template.html"></template>
